<template>
  <div v-loading="loading">
    <div class="m-b-20 ovf-hd">
      <div class="fl" v-show="addShow">
        <router-link class="btn-link-large add-btn" to="add">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;添加文档
        </router-link>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" @selection-change="selectItem">
      <!-- <el-table-column type="selection" width="50">
      </el-table-column> -->
      <el-table-column label="接口名称" prop="title" width="300">
      </el-table-column>
      <el-table-column label="模块" prop="module" width="200">
      </el-table-column>
      <el-table-column label="控制器" prop="controller">
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template scope="scope">
          <div>
            <span v-show="editShow">
              <router-link :to="{ name: 'docsEdit', query: { id: scope.row.id }}" class="btn-link edit-btn m-r-5">
            编辑
              </router-link>
            </span>
            <span v-show="deleteShow">
              <el-button size="small" @click="confirmDelete(scope.row)">删除</el-button>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import btnGroup from '../../Common/normal/btn-group.vue'
  import http from '../../../assets/js/http'

  export default {
    data() {
      return {
        tableData: [],
        currentPage: null,
        keywords: '',
        multipleSelection: [],
        loading: false,
        limit: 15
      }
    },
    methods: {
      search() {
        router.push({ name: 'docsList', query: { page: 1, keywords: this.keywords }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ name: 'docsList', query: { page: page, keywords: this.keywords }})
      },
      getDocs() {
        this.loading = true
        this.apiGet('admin/docs').then((res) => {
          this.loading = false
          if (res.code == 200) {
            this.tableData = res.data
          } else {
            _g.dealError(this, res)
          }
        })
      },
      confirmDelete(item) {
        this.$confirm('确认删除该文档?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.apiDelete('admin/docs/', item.id).then((res) => {
            if (res.code == 200) {
              _g.toastMsg(this, 'success', '删除成功')
              _g.reloadPage(this)
            } else {
              _g.dealError(this, res)
            }
          })
        }).catch(() => {
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      init() {
        this.getCurrentPage()
        this.getKeywords()
        this.getDocs()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('')
      },
      editShow() {
        return _g.getHasRule('')
      },
      deleteShow() {
        return _g.getHasRule('')
      }
    },
    watch: {
      '$route'(to, from) {               // 监听路由改变
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }

</script>


// WEBPACK FOOTER //
// list.vue?85648c84